import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import _ from 'lodash';

import { fetchAllSamples } from './charSamplesSlice';
import { getUserId } from './userSlice';
export const SEQ_STATE_FLAGS = {
  IS_INHIBIT_PAGE_CHANGE: 0x01,
  IS_DIRTY: 0x02,
  IS_OVERWRITE: 0x04
}

export const apsPageStateDef = {
  prev_sampleList: {},
  sampleList: {},
  filteredSnipList: {},
  aggregatedSnips: [],
  filterSelection: "All",
  searchText: "",
  itemsPerPage: -1,
  pageCount: 1,
  showPager: false,
  activePage: 1,
  emptyDisplay: false,
  selectionCount: {
    samples: {},
    has_samples_selected: false,
    filteredSnipList: {},
    has_filtered_samples_selected: false,
    aggregatedSnips: {},
    has_aggregated_samples_selected: false,
  },
  isEmptySnipView: true,
  fileListView: "",
  activeUid: ""
}

export const apsPageStateManager = createAsyncThunk(
  'apiSnipuments/pageStateManager',
  async (props, { dispatch, getState }) => {
    const state = getState();
    const user_uid = getUserId(state);

    if (props.doSnipListFetch) {
      try {
        const data = await dispatch(fetchAllSamples({ userId: user_uid })).unwrap();

        let apsPageStateObj = _.cloneDeep(state.user.aaiSnipSeq.apsPageStateObj);
        apsPageStateObj.sampleList = { ...data.samples.sampleList.samples };

        // Dispatching the fcProcessPageState action
        dispatch(fcProcessPageState(apsPageStateObj));

        // Get the updated state
        const updatedState = getState().user.aaiSnipSeq.apsPageStateObj;
        return updatedState;
      } catch (error) {
        // Handle the error as you see fit.
        throw error;
      }
    } else {
      let apsPageStateObj = _.cloneDeep(state.user.aaiSnipSeq.apsPageStateObj);
      apsPageStateObj.sampleList = [];
      // If you don’t need to update Redux state when doSnipListFetch is falsy,
      // you can return the locally modified apsPageStateObj.
      return apsPageStateObj;
    }
  }
);



// // INITIALIZE
// const initialState = {
//   // SEQUENCER STATE FLAGS
//   ssmSetSeqState: { fulfilled: true, pending: false, rejected: false, data: {}, error: null },

//   // PROCESS Ops
//   // default pageState
//   apsPageStateObj: _.cloneDeep(apsPageStateDef),
//   // CHANGE DETECTION MANAGER INITIALIZE
//   ssmRefreshEntityListCount: 0,
//   // fcClearFileChangedList: [],
//   fcAddUidToInhibitList: [],

//   ssmSetCopySnippetState: { snippetTextCopy: {}, snippetClone: {} },
// }

export const aaiSnipSeqSlice = createSlice({
  name: 'aaiSnipSeq',
  initialState: {
    ssmSetSeqState: { fulfilled: true, pending: false, rejected: false, data: {}, error: null },    // SEQUENCER STATE FLAGS
    apsPageStateObj: _.cloneDeep(apsPageStateDef), // PROCESS Ops // default pageState
    ssmRefreshEntityListCount: 0, // CHANGE DETECTION MANAGER INITIALIZE
    fcAddUidToInhibitList: [],
    ssmSetCopySnippetState: { snippetCloneState: {} },
    ssmSetSnippetSelectionItem: {}
  },
  reducers: {
    // ssmSetSeqState: (state, action) => { state.ssmSetSeqState = action.payload; },
    // ssmSetCopySnippetText: (state, action) => {
    //   state.ssmSetCopySnippetState.snippetTextCopy = action.payload;
    //   state.ssmSetCopySnippetState.snippetClone = action.payload;

    // },
    ssmSetCopySnippetClone: (state, action) => {
      console.log('ssmSetCopySnippetClone', action)
      state.ssmSetCopySnippetState.snippetCloneState = action.payload;
      // state.ssmSetCopySnippetState.snippetTextCopy = action.payload;
    },
    ssmSetSnippetSelected: (state, action) => {
      if (state.ssmSetSnippetSelectionItem[action.payload.uuid] !== undefined) {
        delete state.ssmSetSnippetSelectionItem[action.payload.uuid]
        // if selections are empty set filter to all
        if (_.isEmpty(state.ssmSetSnippetSelectionItem)) {
          let apsObj = { ...state.apsPageStateObj, filterSelection: "All" }
          return aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: apsObj })
        }
        else {
          // if not empty, redraw list (reprocess PageState)
          let apsObj = { ...state.apsPageStateObj }
          return aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: apsObj })
        }
      }
      else {
        state.ssmSetSnippetSelectionItem[action.payload.uuid] = action.payload.uuid;
      }

    },
    // ssmSetActiveUid: (state, action) => {
    //   state.apsPageStateObj.activeUid = action.payload
    // },
    // ssmSetRefreshEntityListFlag: (state, action) => {
    //   state.ssmRefreshEntityListCount += 1
    // },
    fcSetPageStateFilter: (state, action) => {
      let apsObj = { ...action.payload.apsPageState, filterSelection: action.payload.filterSelection }
      return aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: apsObj })
    },
    fcSetPageStateActivePage: (state, action) => {
      let activePage = isNaN(action.payload.activePage) ? 1 : action.payload.activePage;
      let apsObj = { ...state.apsPageStateObj, activePage: activePage }
      return aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: apsObj })
    },
    fcSetPageStateItemPerPage: (state, action) => {
      let itemsPerPage = isNaN(action.payload.itemsPerPage) ? 10 : action.payload.itemsPerPage;
      let pageCount = state.apsPageStateObj.itemsPerPage > 0 ? Math.ceil(state.apsPageStateObj.aggregatedSnips.length / state.apsPageStateObj.itemsPerPage) : 0;
      let showPager = !!(pageCount > 1)
      let apsObj = { ...state.apsPageStateObj, itemsPerPage: itemsPerPage, pageCount: pageCount, showPager: showPager }
      return aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: apsObj })
    },
    fcSetPageStateFilterSnipList: (state, action) => {
      state.apsPageStateObj.filteredSnipList = action.payload.filteredSnipList;
      aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: state.apsPageStateObj })
    },
    // fcSetPageStateFilterAndAggregatedFiles: (state, action) => {
    //   state.apsPageStateObj.filteredSnipList = action.payload.filteredSnipList;
    //   state.apsPageStateObj.aggregatedSnips = action.payload.aggregatedSnips;

    //   aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: state.apsPageStateObj })
    // },
    // fcSetPageStateSnipListAndAggregatedFiles: (state, action) => {
    //   state.apsPageStateObj.sampleList = action.payload.sampleList;
    //   state.apsPageStateObj.aggregatedSnips = action.payload.aggregatedSnips;

    //   aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: state.apsPageStateObj })
    // },
    // fcSetPageStateSnipListAndFilteredAndAggregatedFiles: (state, action) => {
    //   state.apsPageStateObj.sampleList = action.payload.sampleList;
    //   state.apsPageStateObj.filteredSnipList = action.payload.filteredSnipList;
    //   state.apsPageStateObj.aggregatedSnips = action.payload.aggregatedSnips;

    //   // aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: state.apsPageStateObj })
    //   let pgStateObj = aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: state.apsPageStateObj })
    //   state.apsPageStateObj = { ...pgStateObj.apsPageStateObj };
    // },
    // fcSetPageStateSetAllChecks: (state, action) => {
    //   let uid = action.payload.uid;
    //   let isChecked = action.payload.isChecked;
    //   // aggregatedSnips is array
    //   _.map(state.apsPageStateObj.aggregatedSnips, x => { if (x.uid === uid || uid === '') x.isSelected = isChecked; return x; });
    //   Object.values(state.apsPageStateObj.filteredSnipList.samples).map(x => { if (x.uid === uid || uid === '') x.isSelected = isChecked; return x; });
    //   Object.values(state.apsPageStateObj.sampleList).map(x => { if (x.uid === uid || uid === '') x.isSelected = isChecked; return x; });
    //   // reevaluate page state with adjusted lists
    //   let pgStateObj = aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: state.apsPageStateObj })
    //   // update/overwrite state obj
    //   state.apsPageStateObj = { ...pgStateObj.apsPageStateObj };
    //   // update pageState with whole obj
    //   aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: state.apsPageStateObj })

    // },
    fcSetPageStateSearchText: (state, action) => {
      let apsObj = { ...action.payload.apsPageState, searchText: action.payload.searchText }
      return aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: apsObj })
    },
    fcSetActiveUid: (state, action) => {
      let apsObj = { ...action.payload.apsPageState, activeUid: action.payload.activeUid }
      return aaiSnipSeqSlice.caseReducers.fcProcessPageState(state, { payload: apsObj })
    },
    fcProcessPageState: (state, action) => {
      const { sampleList, filterSelection, searchText, itemsPerPage, activePage, updateType, activeUid } = action.payload;
      let filteredSnipList = _.cloneDeep(sampleList);
      let aggregatedSnips = [];
      let snipArray = _.values(filteredSnipList);
      let filteredSnip = {};
      let itemsPerPage_t = itemsPerPage === "All" ? -1 : itemsPerPage;

      switch (filterSelection) {
        // case 'Characters': // if has_recipient.person.length > 0 || has_recipient.organization.length > 0
        //   _.forEach(snipArray, snip => {
        //     if (snip.has_recipient !== undefined && (snip.has_recipient.person.length > 0 ||
        //       snip.has_recipient.organization.length > 0 ||
        //       snip.has_recipient.album.length > 0)) filteredSnip[snip.uid] = snip;
        //   })
        //   break;
        case 'Sample Name': // if has_recipient.person.length === 0 && has_recipient.organization.length === 0
          _.forEach(snipArray, snip => {
            if (snip.has_recipient === undefined || (snip.has_recipient.person.length === 0 && snip.has_recipient.organization.length === 0 && snip.has_recipient.album.length === 0)) filteredSnip[snip.uid] = snip;
          })
          break;
        case 'Sample Text': // if has_albumList.length > 0
          _.forEach(snipArray, snip => {
            if (snip.textSnippet.displayText !== undefined &&
              snip.textSnippet.displayText.length > 0 &&
              snip.textSnippet.displayText !== "Uninitialized") {
              filteredSnip[snip.uuid] = snip;
            }
          })
          break;
        case 'Sample Text Variation': // if has_albumList.length > 0
          _.forEach(snipArray, snip => {
            if (snip.textSnippet.displayText !== undefined &&
              snip.textSnippet.displayText.length > 0 &&
              snip.textSnippet.displayText !== "Uninitialized") {
              filteredSnip[snip.uuid] = snip.uuid;
            }
          })
          break;
        case 'Selected':
          console.log('Selected', state.ssmSetSnippetSelectionItem)
          _.forEach(snipArray, snip => {
            if (snip !== undefined && (state.ssmSetSnippetSelectionItem[snip.uuid])) {
              filteredSnip[snip.uuid] = snip;
            }
          })

          break;
        case 'Title':
          _.forEach(snipArray, snip => {
            if (snip !== undefined && (snip.isSelected)) filteredSnip[snip.uid] = snip;
          })
          break;
        case "All":
        default:
          state.ssmSetSnippetSelectionItem = {};
          filteredSnip = sampleList;
          break;
      }

      filteredSnipList.samples = filteredSnip;

      // rebuild aggregatedSnips from filtered SnipList
      // console.log('filteredSnipList.samples', filteredSnipList.samples)
      if (filteredSnipList !== undefined && !_.isEmpty(filteredSnipList.samples)) {
        aggregatedSnips = _.values(filteredSnipList.samples);

        let upType = updateType;
        if (searchText === '') upType = "noSearchData";
        switch (upType) {
          case "noSearchData":
            state.ssmSetSnippetSelectionItem = {};
            filteredSnip = sampleList;
            aggregatedSnips = _.values(filteredSnipList.samples);
            break;
          case "searchChange":
          default:

            filteredSnipList.samples = {};
            _.forEach(aggregatedSnips, (snip, index) => {
              const re = new RegExp(_.escapeRegExp(searchText), 'i');

              const isMatch = snip => {
                let isFound = !!(re.test(snip.textSnippet.displayText) | re.test(snip.textSnippet.fileName) | re.test(snip.textSnippet.variation) |
                  re.test(snip.title));
                console.log('displayText', snip.textSnippet.displayText, 'fileName', snip.textSnippet.fileName, 'variation', snip.textSnippet.variation)
                return isFound;
              };
              if (isMatch(snip)) filteredSnipList.samples[snip.uid] = snip;
            });
            aggregatedSnips = _.values(filteredSnipList.samples);
            break;
        }
      }
      else {
        filteredSnipList.samples = {};
        aggregatedSnips = [];
      }

      // Process Selections
      // let selectCounts = {
      //   samples: _.countBy(_.values(sampleList), x => x.isSelected === true),
      //   // has_samples_selected: false,
      //   filteredSnipList: _.countBy(_.values(filteredSnipList.samples), x => x.isSelected === true),
      //   has_filtered_samples_selected: false,
      //   aggregatedSnips: _.countBy(aggregatedSnips, x => x.isSelected === true),
      //   has_aggregated_samples_selected: false,
      //   agg_uploads: _.countBy(aggregatedSnips, x => x.workerObj !== undefined),
      //   // has_agg_uploads: false,
      //   selectCountsPrompt: "NO SELECTIONS"
      // }

      // selectCounts.has_samples_selected = selectCounts.samples.true !== undefined;
      // selectCounts.has_filtered_samples_selected = selectCounts.filteredSnipList.true !== undefined;
      // selectCounts.has_aggregated_samples_selected = selectCounts.aggregatedSnips.true !== undefined;
      // selectCounts.has_agg_uploads = selectCounts.has_agg_uploads.true !== undefined;

      // if (selectCounts.has_filtered_samples_selected) selectCounts.selectCountsPrompt = "SELECTIONS"



      let pageCount = itemsPerPage > 0 ? Math.ceil(aggregatedSnips.length / itemsPerPage) : 0;
      if (isNaN(pageCount)) pageCount = 1;

      let aggSnips = _.cloneDeep(aggregatedSnips)
      let itemsPg = Number(itemsPerPage_t);

      if (itemsPerPage_t === -1) { }
      else {
        if (itemsPg < 1) itemsPg = 1;

        let curPageStart = (Number(activePage) - 1) * itemsPg;
        let endPageItem = curPageStart + itemsPg;

        aggSnips = aggSnips.slice(curPageStart, endPageItem);
      }

      let results = {
        sampleList: sampleList,
        filteredSnipList: filteredSnipList,
        aggregatedSnips: aggSnips, //aggregatedSnips,
        filterSelection: filterSelection,
        searchText,
        itemsPerPage: itemsPerPage_t,
        pageCount: pageCount,
        showPager: pageCount > 1,
        activePage: activePage,
        emptyDisplay: _.isEmpty(filteredSnipList.samples),
        // selectionCount: selectCounts,
        isEmptySnipView: true, //(sampleList.empty_snippet !== undefined),
        activeUid: activeUid
      };
      state.apsPageStateObj = results;
      console.log('fcProcessPageState processed')
    }
  },
})

export const {
  apsPageState,
  // ssmSetActiveUid,
  // ssmSetRefreshEntityListFlag,
  ssmSetSeqState,
  // ssmSetCopySnippetText,
  ssmSetCopySnippetClone,
  ssmSetSnippetSelected,
  fcAddUidToInhibitList,
  fcProcessPageState,
  fcSetPageStateFilter,
  fcSetPageStateActivePage,
  fcSetPageStateItemPerPage,
  fcSetPageStateFilterSnipList,
  // fcSetPageStateFilterAndAggregatedFiles,
  // fcSetPageStateSnipListAndAggregatedFiles,
  // fcSetPageStateSnipListAndFilteredAndAggregatedFiles,
  // fcSetPageStateSetAllChecks,
  // fcSetPageStateSnipList,
  fcSetPageStateSearchText,
} = aaiSnipSeqSlice.actions;

export default aaiSnipSeqSlice.reducer;

// export const getSsmSeqState = (state) => state.user.aaiSnipSeq.ssmSetSeqState
// export const getSsmPageState = (state) => state.user.aaiSnipSeq.apsPageState
// export const getSsmPageStateObj = (state) => state.user.aaiSnipSeq ? state.user.aaiSnipSeq.apsPageStateObj : _.cloneDeep(apsPageStateDef)
// export const getSsmActiveUid = (state) => state.user.aaiSnipSeq.apsPageStateObj.activeUid === "" ? "editViewID" : state.user.aaiSnipSeq.apsPageStateObj.activeUid
// export const getSsmPageStateFileByUid = (state, uid) => {
//   return state.user.aaiSnipSeq.apsPageStateObj.sampleList[uid]
// }
// export const selectRefreshListFlag = (state) => state.user.aaiSnipSeq.ssmRefreshEntityListCount
// export const getRefreshListFlag = (state) => state.user.aaiSnipSeq.ssmRefreshEntityListCount

// export const selectSsmPageState = (state) => state.user.aaiSnipSeq.apsPageState
// export const selectActiveUid = (state) => state.user.aaiSnipSeq.apsPageStateObj.activeUid

// CHANGE DETECTION MANAGER GETTERS
// export const getFcfileChangeListCount = (state) => state.user.aaiSnipSeq.fcAddUidToInhibitList.length
// export const getFcUidToInhibitList = (state) => state.user.aaiSnipSeq.fcAddUidToInhibitList
// export const getFcfileChangeTrueListCount = (state) => {
//   // let isDirtyCount = _.countBy(state.user.aaiSnipSeq.fcAddUidToInhibitList, x => x.isDirty === true);
//   // console.log('aggregatedSnips', state.user.aaiSnipSeq.apsPageStateObj.aggregatedSnips)
//   // let isDirtyCount = _.countBy(state.user.aaiSnipSeq.apsPageStateObj.aggregatedSnips, x => x.isDirty || x.isFirstMultiLoadEvent);
//   let StatusCounts = {
//     isDirty: 0,
//     isFirstMultiLoadEvent: 0,
//     isChangedCount: 0
//   }
//   _.forEach(state.user.aaiSnipSeq.apsPageStateObj.aggregatedSnips, x => {
//     if (x.isDirty) StatusCounts.isDirty++
//     if (x.isFirstMultiLoadEvent) StatusCounts.isFirstMultiLoadEvent++;
//     if (x.isDirty || x.isFirstMultiLoadEvent) StatusCounts.isChangedCount++;
//   })
//   // let isDirtyCount = state.user.aaiSnipSeq.fcAddUidToInhibitList.length;

//   if (StatusCounts.isChangedCount !== 0) console.log('StatusCounts.isDirty', StatusCounts.isDirty,
//     'isFirstMultiLoadEvent', StatusCounts.isFirstMultiLoadEvent, 'isChangedCount', StatusCounts.isChangedCount,
//     'fcAddUidToInhibitList', state.user.aaiSnipSeq.fcAddUidToInhibitList)
//   return StatusCounts.isChangedCount;
// }

// CHANGE DETECTION MANAGER SELECTORS
// export const selectIsAnyFileChanged = (state) => state.user.aaiSnipSeq.fcAddUidToInhibitList.length
// export const selectFileChangeListCount = (state) => state.user.aaiSnipSeq.fcAddUidToInhibitList.length

// SNIPPET TEXT COPY AND SNIPPET CLONE SELECTORS
// export const selectSnippetCopyText = (state) => {
//   try {
//     return state.user.aaiSnipSeq.ssmSetCopySnippetState.snippetTextCopy;

//   }
//   catch (error) {
//     return null;
//   }
// }
// export const selectSnippetClone = (state) => {
//   try {
//     return state.user.aaiSnipSeq.ssmSetCopySnippetState.snippetClone;

//   }
//   catch (error) {
//     return null;
//   }
// }

export const selectedSnippet = (state) => {
  return state.user.aaiSnipSeq.ssmSetCopySnippetState;
}

export const selectedSnippetCloneObj = (state) => {
  let snippetCloneState = state.user.aaiSnipSeq.ssmSetCopySnippetState.snippetCloneState;
  if (!_.isEmpty(snippetCloneState)) return snippetCloneState;

  return { uuid: "", copyType: "New Snippet" };
}

export const selectSnippetSelectionItemList = (state) => {
  return state.user.aaiSnipSeq.ssmSetSnippetSelectionItem;
}